<template>
  <div class="w-full">
    <Hero />
    <Services />
    <About />
  </div>
</template>

<script>
import Hero from '../components/HeroGlobal.vue';
import Services from '../components/ServicesGlobal.vue';
import About from '../components/AboutUs.vue';

export default {
  components: {
    Hero,
    Services,
    About
  }
}
</script>